export const STRINGS = {
  'generic.something_went_wrong': 'Something went\u00a0wrong!',

  'login.title': 'Sign In To Belong',
  'login.forgot_password': 'FORGOT PASSWORD',
  'login.sign_in': 'Sign In',
  'login.sign_up_title': 'Not a Belong member?',
  'login.sign_up_cta': 'SIGN UP',
  'login.or': 'Or',
  'login.something_went_wrong':
    'Something went wrong. Please sign in if you have an\u00a0existing\u00a0account.',
  'login.credentials_error': 'Invalid Email/Password',
  'login.fb_login_email_mismatch_line_1':
    'Looks like your Facebook account\u00a0doesn’t\u00a0match.',
  'login.fb_login_email_mismatch_line_2':
    'Please create an account with the email\u00a0below.',
  'login.google_third_party_error':
    'Please allow 3rd-party cookies to login with\u00a0Google.',

  'sign_up.title': 'Become a Belong Member!',
  'sign_up.cta': 'Create Account',
  'sign_up.already_a_member': 'Already a member?',
  'sign_up.sign_in': 'SIGN IN',
  'sign_up.email_taken_line1': 'Unable to register. Please ',
  'sign_up.email_taken_line2': ' or use Forgot Password to recover access.',
  'sign_up.email_taken':
    'Unable to register. Please sign in or use Forgot Password to recover access.',
  'sign_up.email_taken_button': ' SIGN IN',
  'sign_up.error':
    'Hmm... we were unable to create this account. Please sign in if you have an\u00a0existing\u00a0account.',

  'forgot_password.title': 'Forgot your password?',
  'forgot_password.subtitle': `Enter your email address and we'll send you an email containing a link to reset\u00a0your\u00a0password.`,
  'forgot_password.cta': 'Reset Password',
  'forgot_password.success.title': 'No problem!',
  'forgot_password.success.subtitle': `We'll send you an email to reset your password if this Belong account exists.`,
  'forgot_password.success.cta': 'Done',

  'enter_contact.homeowner-title':
    'Add your phone number to get your inspection locked\u00a0in\u00a0today.',
  'enter_contact.resident-title':
    'Add your phone number to discover property\u00a0management\u00a0reimagined.',
  'enter_contact.generic-title':
    'Add your phone number to receive more timely\u00a0updates.',
  'enter_contact.subtitle': 'Connected To',
  'enter_contact.cta': 'Save',
  'enter_contant.contact_update_failed': `Unable to update phone. Please\u00a0try\u00a0again.`,
  'enter_contant.phone_already_exists':
    'That phone number is already in use by another user\u00a0account!',

  'set_password.title': `Let's reset your\u00a0password!`,
  'set_password.subtitle': 'What should your new password\u00a0be?',
  'set_password.cta': 'Update Password',
  'set_password.new_user.title': `Become a Belong\u00a0Member.`,
  'set_password.new_user.subtitle': `Let's set up your account, starting with a\u00a0password.`,
  'set_password.new_user.cta': 'Create Account',
  'set_password.success_title': 'Password successfully\u00a0updated.',
  'set_password.success_cta': 'Back To Sign In',
  'set_password.error.token_line_1': `This link has expired. Please`,
  'set_password.error.reset_password': `RESET YOUR PASSWORD`,
  'set_password.again.again': `again.`,
  'set_password.footer.agreement': 'By continuing, I agree to Belong’s',
  'set_password.footer.privacy': 'PRIVACY POLICY',
  'set_password.footer.and': 'and',
  'set_password.footer.terms': 'TERMS OF SERVICE',

  // Set password strings by section
  'wealth.set_password.title': 'Lastly, let’s set a password!',
  'wealth.set_password.subtitle':
    'You can access your wealth analysis at any time from your account.',
  'wealth.set_password.cta': 'Create Account',

  'w9.set_password.title': 'Congrats! You’re a Belong\u00a0Member!',
  'w9.set_password.subtitle':
    'Now, let’s set up your accounts, starting with a\u00a0password.',
  'w9.set_password.cta': 'Create Password',

  'terms_footer.first_line': 'By continuing, I agree to Belong’s',
  'terms_footer.privacy': 'PRIVACY POLICY',
  'terms_footer.and': 'and',
  'terms_footer.terms': 'TERMS OF SERVICE',

  enterContactInformation: 'Enter your phone or email to\u00a0continue.',
  enterEmailAndPassword: 'Enter your email and password to\u00a0continue.',
  noPasswordRequired: 'No Password Required',
  continue: 'Continue',
  orSignInWith: 'Or Sign In With',
  emailOrPhone: 'Email Or Phone',
  addMissingInformation: 'Add your contact info to receive\u00a0updates.',
  connectedGoogle: 'Connected Google',
  connectedFacebook: 'Connected Facebook',
  connectedApple: 'Connected Apple',
  enterSmsCode: 'Enter the code we just texted\u00a0you.',
  enterEmailCode: 'Enter the code we just emailed\u00a0you.',
  magicLink: 'We emailed you a magic\u00a0link.',
  magicLinkDescription1: 'Please check your',
  magicLinkDescription2: 'email, and click the link to log in to\u00a0Belong.',
  enterCode1: 'Enter the code',
  enterSmsCode2: 'we just texted\u00a0you.',
  enterEmailCode2: 'we just emailed\u00a0you.',
  phone: 'Phone',
  email: 'Email',
  code: '6-Digit Code',
  signIn: 'Sign In',
  resendCode: 'RESEND CODE',
  reEnterPhoneNumber: 'RE-ENTER PHONE NUMBER',
  reEnterEmail: 'RE-ENTER EMAIL',
  resendCodeSuccess:
    'Successfully resend code. Please check your phone\u00a0message.',
  resendEmailCodeSuccess:
    'Successfully resend magic link. Please check your\u00a0email.',
  multipleAccounts:
    'We found multiple accounts associated with this\u00a0number.',
  multipleAccountsDescription:
    'Choose one, and we’ll send you an email to confirm your\u00a0account.',
  multipleEmailsCta: 'Next',
  expiredCode:
    'Looks like that code has expired. Please resend it and try\u00a0again!',
  expiredMagicLink:
    'Looks like that magic link has expired. Please resend it and try\u00a0again!',
  nonExistentAccount: 'Invalid {authenticationMethod}. Please try\u00a0again.',
  generalError: 'Something went wrong. Please try\u00a0again.',
  unmatchedCode: 'That code did not match. Please try\u00a0again.',
  useCode: 'Use Code',
  useMagicLink: 'Use Magic Link',
  lastUsed: 'Last Used',
  lastUsedEmail: 'Last Used | Email',
  lastUsedPhone: 'Last Used | Phone',
};
